/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamPlayerVerificationStatus } from './PamPlayerVerificationStatus';
import {
    PamPlayerVerificationStatusFromJSON,
    PamPlayerVerificationStatusFromJSONTyped,
    PamPlayerVerificationStatusToJSON,
} from './PamPlayerVerificationStatus';

/**
 * A failed-verification row as shown in the back-office manual-review list. Identity is
 * served from PDS (name + email denormalized on pam_player); no Clerk call.
 * @export
 * @interface PamVerificationSummary
 */
export interface PamVerificationSummary {
    /**
     * 
     * @type {string}
     * @memberof PamVerificationSummary
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationSummary
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationSummary
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationSummary
     */
    latestReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationSummary
     */
    latestReasonCode?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PamVerificationSummary
     */
    verificationStatusChangedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof PamVerificationSummary
     */
    attemptCount: number;
    /**
     * 
     * @type {PamPlayerVerificationStatus}
     * @memberof PamVerificationSummary
     */
    status: PamPlayerVerificationStatus;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationSummary
     */
    clerkUserId: string;
    /**
     * 
     * @type {string}
     * @memberof PamVerificationSummary
     */
    pamPlayerId: string;
}



/**
 * Check if a given object implements the PamVerificationSummary interface.
 */
export function instanceOfPamVerificationSummary(value: object): value is PamVerificationSummary {
    if (!('verificationStatusChangedAt' in value) || value['verificationStatusChangedAt'] === undefined) return false;
    if (!('attemptCount' in value) || value['attemptCount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('clerkUserId' in value) || value['clerkUserId'] === undefined) return false;
    if (!('pamPlayerId' in value) || value['pamPlayerId'] === undefined) return false;
    return true;
}

export function PamVerificationSummaryFromJSON(json: any): PamVerificationSummary {
    return PamVerificationSummaryFromJSONTyped(json, false);
}

export function PamVerificationSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamVerificationSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'latestReason': json['latestReason'] == null ? undefined : json['latestReason'],
        'latestReasonCode': json['latestReasonCode'] == null ? undefined : json['latestReasonCode'],
        'verificationStatusChangedAt': (new Date(json['verificationStatusChangedAt'])),
        'attemptCount': json['attemptCount'],
        'status': PamPlayerVerificationStatusFromJSON(json['status']),
        'clerkUserId': json['clerkUserId'],
        'pamPlayerId': json['pamPlayerId'],
    };
}

export function PamVerificationSummaryToJSON(value?: PamVerificationSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'latestReason': value['latestReason'],
        'latestReasonCode': value['latestReasonCode'],
        'verificationStatusChangedAt': ((value['verificationStatusChangedAt']).toISOString()),
        'attemptCount': value['attemptCount'],
        'status': PamPlayerVerificationStatusToJSON(value['status']),
        'clerkUserId': value['clerkUserId'],
        'pamPlayerId': value['pamPlayerId'],
    };
}

